/**
 * ------------------------------------------------------------------------
 * HEADER MENU JS
 * ------------------------------------------------------------------------
 */

window.addEventListener('load', () => {

    /**
     * Variable
     *
     * @type {{active: boolean, classHamburgerClose: string, classVisible: string, collapse: *, hamburger: *}}
     */
    let active = false;
    const classHamburgerClose = 'hamburger_close';
    const classVisible = 'header__collapse_show';
    const collapse = document.querySelector('[data-js="header-collapse"]');
    const hamburger = document.querySelector('[data-js="hamburger"]');
    const headerMenuLink = document.querySelectorAll('[data-js="header-menu-link"]');

    /**
     * Open menu function
     *
     * @param button
     */
    const menuOpen = (button) => {
        $('.header__logo').find('.st0_1').addClass('st0');
        active = true;
        collapse.classList.toggle(classVisible);
        button.classList.toggle(classHamburgerClose);

        headerMenuLink.forEach((element, index) => {
            gsap.set(element, { y: '100%' });
        });

        setTimeout(() => {
            headerMenuLink.forEach((element, index) => {
                gsap.to(element, { y: 0, ease: 'Power4.easeOut', duration: .8, delay: .2 * index });
            });
        }, 400);
    }

    /**
     * Close menu function
     *
     * @param button
     */
    const menuClose = (button) => {
        button.classList.toggle(classHamburgerClose);
        collapse.classList.toggle(classVisible);
        active = false;
        // $('.header__logo').find('.st0_1').removeClass('st0');

        // Resetta tutti i sotto-menu
        document.querySelectorAll('.header-menu__subnav').forEach(subMenu => {
            subMenu.style.maxHeight = "0px";
        });
    }

    /**
     * Run on click function
     */
    if (hamburger !== null) {
        hamburger.addEventListener('click', (e) => {
            if(active) {
                menuClose(e.target);
                document.body.style.overflow = "";
            } else {
                menuOpen(e.target);
                document.body.style.overflow = "hidden";
            }
        });
    }
});

/**
 * Toggle submenu function
 *
 * @param e
 */
const headerMenuToggle = (e) => {
    let subMenu = e.nextElementSibling;
    subMenu.style['maxHeight'] = subMenu.style['maxHeight'] === '0px' ? '300px' : '0px';
}




// /**
//  * ------------------------------------------------------------------------
//  * HEADER MENU JS
//  * ------------------------------------------------------------------------
//  */
//
// window.addEventListener('load', () => {
//
//     /**
//      * Variables
//      */
//     let active = false;
//     const classHamburgerClose = 'hamburger_close';
//     const classVisible = 'header__collapse_show';
//     const collapse = document.querySelector('[data-js="header-collapse"]');
//     const hamburger = document.querySelector('[data-js="hamburger"]');
//     const headerMenuLink = document.querySelectorAll('[data-js="header-menu-link"]');
//     const customTimeline = document.querySelector('.customTimeline'); // Seleziona l'elemento customTimeline
//
//     /**
//      * Open menu function
//      *
//      * @param button
//      */
//     const menuOpen = (button) => {
//         $('.header__logo').find('.st0_1').addClass('st0');
//         active = true;
//         collapse.classList.toggle(classVisible);
//         button.classList.toggle(classHamburgerClose);
//         document.body.style.overflow = "hidden";
//
//         // Rimuove la classe "isShow" da .customTimeline se presente
//         if (customTimeline && customTimeline.classList.contains('isShow')) {
//             customTimeline.classList.remove('isShow');
//             customTimeline.dataset.wasIsShow = "true"; // Salva lo stato precedente
//         }
//
//         headerMenuLink.forEach((element, index) => {
//             gsap.set(element, { y: '100%' });
//         });
//
//         setTimeout(() => {
//             headerMenuLink.forEach((element, index) => {
//                 gsap.to(element, { y: 0, ease: 'Power4.easeOut', duration: .8, delay: .2 * index });
//             });
//         }, 400);
//     }
//
//     /**
//      * Close menu function
//      *
//      * @param button
//      */
//     const menuClose = (button) => {
//         button.classList.toggle(classHamburgerClose);
//         collapse.classList.toggle(classVisible);
//         active = false;
//         document.body.style.overflow = "";
//
//         // Ripristina la classe "isShow" su .customTimeline se era presente prima dell'apertura del menu
//         if (customTimeline && customTimeline.dataset.wasIsShow === "true") {
//             customTimeline.classList.add('isShow');
//             delete customTimeline.dataset.wasIsShow; // Rimuove il dato temporaneo
//         }
//     }
//
//     /**
//      * Run on click function
//      */
//     if (hamburger !== null) {
//         hamburger.addEventListener('click', (e) => {
//             if(active) {
//                 menuClose(e.target);
//             } else {
//                 menuOpen(e.target);
//             }
//         });
//     }
// });
//
// /**
//  * Toggle submenu function
//  *
//  * @param e
//  */
// const headerMenuToggle = (e) => {
//     let subMenu = e.nextElementSibling;
//     subMenu.style['maxHeight'] = subMenu.style['maxHeight'] === '0px' ? '300px' : '0px';
// }
